import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { BasicCollectionService } from 'app/back-office/shared/services/back-office/basic-collection.service';
import { ProductsService } from 'app/back-office/shared/services/back-office/products.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-basic-collection-filter',
    templateUrl: './basic-collection-filter.component.html',
    styleUrls: ['./basic-collection-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BasicCollectionFilterComponent implements OnInit {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  @Input() use4shopId: boolean;

  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search collection...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [];
  constructor(private basicColletionService: BasicCollectionService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 0) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    this.setDataToView(0);
  }

  setDataToView(skipCount: number) {
    this.basicColletionService.getAllBasicCollections(this.loaderId, {
      skipCount,
      maxResultCount: 20,
      searchString: this.searchValue
    }).subscribe(res => {
      this.dataToView = res.items.map(el =>
        FilterMapper.basicCollectionFilter(el, this.use4shopId)
      );

      this.totalCount = res.totalCount;
    });
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount;
      this.setDataToView(next);
    }
  }

}
